import { isTablet } from '../base'

export function newsletter() {
    const newsletter = $('.custom-footer__newsletter')

    newsletter.addClass('container').insertBefore('#footer')
    newsletter.find('.topic span').text('Newsletter')
    newsletter.find('input').attr('placeholder', 'Váš e-mail')
    newsletter.contents().wrapAll($('<div class="newsletter-wrapper"></div>'))
    newsletter.find('.btn').text('Přihlásit se k odběru')

    if (isTablet()) return

    newsletter.find('.btn').insertAfter(newsletter.find('input.form-control'))
}
